import _ from 'underscore';
import Promise from 'bluebird';
import * as Constants from './constants';
import { InlineChartRequest } from './inline-chart-request';

export class InlineChartService {
  constructor(options) {
    this.request = new InlineChartRequest(options);
    this.jsdata = options.jsdata;
    this.edm = options.edm;
  }

  findAll = context => (new Promise((resolve, reject) => {
    const filterObj = context.filter;
    // Ignore filter string for SearchTerm
    const filterString = filterObj && filterObj.odataV4
      && context.currentEntity !== Constants.EntityName.SearchTermEntity ?
      filterObj.odataV4({ ignoreCase: false }) :
      '';

    const request = this.request.getQuery(context);
    if (!this.jsdata.PerformanceTimeSeries || !this.jsdata.PerformanceTimeSeries.findAll) {
      return;
    }

    // eslint-disable-next-line consistent-return
    return this.jsdata.PerformanceTimeSeries.findAll(
      {
        where: filterString,
        entitySet: this.getScope(request).toJSON(),
      },
      {
        // bypass cache, as inline chart needs data aligned with grid, we need always
        // update to date here use bypassCache instead of cacheResponse as elsewhere
        // (performance card) may cache the response
        bypassCache: true,
      }
    ).then((rawData) => {
      resolve(rawData);
    }, reject);
  }));

  getScope = (request) => {
    let navigation = null;

    navigation = this.getNavigation(request.edmEntity);

    _.each(request.parentLevels, (nav) => {
      const navLocal = nav;
      if (navLocal && _.isString(navLocal.id)) {
        navLocal.id = parseInt(nav.id, 10);
      }
      navigation = navigation[navLocal.name].$withKey(navLocal.id);
    });

    if (request && request.edmEntity) {
      navigation = navigation[request.edmEntity];
    }

    const entitySetArgs = {
      granularity: `Enum.Granularity'${request.granularity}'`,
      startDate: request.startDate,
      endDate: request.endDate,
      comparisonStartDate: request.compareStartDate ? request.compareStartDate : null,
      comparisonEndDate: request.compareEndDate ? request.compareEndDate : null,
      metrics: `'${request.metrics}'`,
      movingAverage: request.movingAverage,
    };

    if (request.currentCustomerId) {
      entitySetArgs.currentCustomerId = request.currentCustomerId;
    }

    const isHierarchical = request.edmEntity === Constants.EdmEntityName.AccountEdmEntity;
    if (isHierarchical && request.accountModes) {
      entitySetArgs.accountModes = `'${request.accountModes}'`;
    }

    const entitySet = navigation[isHierarchical ? 'Default.HierarchicalPerformanceTimeSeries' : 'Default.PerformanceTimeSeries'].$call(entitySetArgs);
    return entitySet;
  };

  getNavigation = (entityType) => {
    switch (entityType) {
      case Constants.EdmEntityName.AccountEdmEntity:
        return this.edm.currentCustomer;
      case Constants.EdmEntityName.CampaignEdmEntity:
        return this.edm.currentAccount;
      default:
        return this.edm.currentAccount;
    }
  };
}
